"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeddySeeder__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "teddyId",
                type: "uint256",
            },
            {
                internalType: "contract ITeddyDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "generateSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class TeddySeeder__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TeddySeeder__factory = TeddySeeder__factory;
TeddySeeder__factory.bytecode = _bytecode;
TeddySeeder__factory.abi = _abi;
